import * as React from "react";
import type { SVGProps } from "react";

interface FieldGoalProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const FieldGoal = ({ cancelled = false, ...props }: FieldGoalProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none">
      <path
        fill="#000"
        fillRule="evenodd"
        stroke="#FFF"
        strokeWidth={0.95}
        d="M5.65 1.52a1.12 1.12 0 0 1 1.13 1.13v10.88h10.74V2.64c0-.28.1-.54.28-.73 1.2-.5 1.4-.26 1.6-.1.24.21.38.5.38.83v12a1.12 1.12 0 0 1-1.13 1.13h-5.37v5.87a1.12 1.12 0 0 1-1.93.8c-.2-.2-.32-.49-.32-.8v-5.87H5.65a1.12 1.12 0 0 1-1.13-1.13v-12a1.12 1.12 0 0 1 1.13-1.13Z"
      />
      <path
        stroke="#000"
        strokeWidth={0.2}
        d="M5.65 1.9a.75.75 0 0 1 .75.75V13.9h11.5V2.65c0-.19.07-.36.18-.49.74-.28.93-.18 1.07-.05a.7.7 0 0 1 .25.54v12a.75.75 0 0 1-.75.75H12.9v6.25a.75.75 0 0 1-1.28.53.75.75 0 0 1-.22-.53V15.4H5.65a.75.75 0 0 1-.75-.75v-12a.75.75 0 0 1 .75-.75Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default FieldGoal;
